export function getReviewQuestionAnchor(questionId: string): string {
  return `question-${questionId}`
}
